import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { useLogin } from '@/api/hooks'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { fr } from '@/i18n/fr'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const login = useLogin()
  const navigate = useNavigate()
  const location = useLocation()

  function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    login.mutate(
      { email, password },
      {
        onSuccess: () => {
          const from = (location.state as { from?: Location })?.from
          void navigate(from ? `${from.pathname}${from.search}` : '/', { replace: true })
        },
      },
    )
  }

  return (
    <div className="mx-auto max-w-sm">
      <h1 className="mb-6 text-2xl font-semibold tracking-tight">{fr.auth.login.heading}</h1>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="email">{fr.auth.emailLabel}</Label>
          <Input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="password">{fr.auth.passwordLabel}</Label>
          <Input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        {login.isError && (
          <p className="text-sm text-red-700 dark:text-red-400">{fr.auth.login.genericError}</p>
        )}

        <Button type="submit" disabled={login.isPending} className="mt-2">
          {login.isPending ? fr.auth.login.submitting : fr.auth.login.submit}
        </Button>
      </form>

      <p className="mt-6 text-sm text-stone-600 dark:text-stone-400">
        {fr.auth.login.noAccount}{' '}
        <Link to="/register" className="font-medium text-stone-900 underline dark:text-stone-100">
          {fr.auth.login.registerLink}
        </Link>
      </p>
    </div>
  )
}
